var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('iframe',{attrs:{"border":"0","src":"/cs/themes/","width":"100%","height":"100%"}})])
}]

export { render, staticRenderFns }